import { useState } from "react";
import { throwResponseError } from "../../../utils/api-error-utils";
import { getAuthParams } from "../../../utils/pacto-rebates-utils";
import { buildParams } from "../../utils/admin-utils";
import { formatVariluxGoalsResponse } from "../../utils/varilux-goals-utils";

export function useVariluxGoals() {
    const [variluxGoals, setVariluxGoals] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    async function fetchVariluxGoals(pagination = {}) {
        try {
            setLoading(true);
            setError(null);

            const {
                accessToken,
                clientId
            } = getAuthParams();

            const params = buildParams(pagination);

            const requestOptions = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "access_token": accessToken,
                    "client_id": clientId
                }
            };

            const response = await fetch(
                process.env.REACT_APP_ESSILOR_API +
                    `pacto-rebates-admin/v1/varilux?${params.toString()}`,
                requestOptions
                
            );

            if (!response.ok) {
                await throwResponseError(response, "Erro ao buscar metas Varilux.");
            }

            const data = await response.json();
            const variluxGoalsData = data.resultado || [];

            const responsePagination = {
                totalElements: data.totalElementos ?? 0,
                totalPages: data.totalPaginas ?? 0,
                page: data.pagina ?? 0,
                size: data.tamanho ?? pagination.size ?? 10
            };

            const formattedVariluxGoals = Array.isArray(variluxGoalsData)
                ? variluxGoalsData.map(formatVariluxGoalsResponse)
                : [];

            setVariluxGoals(formattedVariluxGoals);

            return {
                ok: true,
                empty: formattedVariluxGoals.length === 0,
                variluxGoals: formattedVariluxGoals,
                pagination: responsePagination
            };
        } catch (requestError) {
            setVariluxGoals([]);
            setError(requestError.message);

            return {
                ok: false,
                reason: "request",
                error: requestError.message
            };
        } finally {
            setLoading(false);
        }
    }

    return {
        variluxGoals,
        loading,
        error,
        refetch: fetchVariluxGoals
    };
}